import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: Error) {
    globalThis.dtrum?.reportError(error);
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
